import React from "react";
import Image from "next/image";

interface Block {
  title: string;
  quote: string;
  sub_title: string;
  description: string;
}
interface Props {
  block: Block;
}
const BeyondRole: React.FC<Props> = ({ block }) => {
  return (
    <section className="relative z-[0] overflow-hidden py-[56px] lg:py-[80px] xl:py-[100px] bg-white ">
      <div className="container">
        <div className={` mb-[32px] lg:mb-[32px] xl:mb-[40px] `}>
          <p className="text-heading-6 font-regular text-primary-text mb-[12px] text-center">
            {block?.sub_title ?? ""}
          </p>
          <h2 className="font-bold text-heading-1 text-primary-text mb-[12px] text-center">
            {block?.title ?? ""}
          </h2>
          <p className="text-heading-6 font-regular text-primary-text mb-[0px] text-center">
            {block?.description ?? ""}
          </p>
        </div>
        <div className="bg-[url('/images/leadership/beyond-bg.png')] bg-no-repeat bg-[length:100%_100%] bg-center p-[100px_30px] xl:p-[130px_100px] flex items-center">
          <div className="bg-white p-[30px_30px] xl:p-[40px_80px] relative z-[1] w-[100%] mx-auto border border-[#B0D9F7]">
            <div className="absolute top-[-60px] xl:top-[-80px] left-[0]">
              <Image
                src="/images/leadership/white-quote-up.svg"
                alt="quote-up"
                className="xl:w-[80px] xl:h-[60px] w-[60px] h-[40px]"
                width={80}
                height={60}
              />
            </div>
            <div className="absolute xl:bottom-[-80px] bottom-[-60px] right-[0]">
              <Image
                src="/images/leadership/white-quote-down.svg"
                alt="quote-down"
                className="xl:w-[80px] xl:h-[60px] w-[60px] h-[40px]"
                width={80}
                height={60}
              />
            </div>
            <h3 className="text-heading-4 font-bold text-primary-text mb-[0px] text-center">
              {block?.quote ?? ""}
            </h3>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BeyondRole;
